var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToDictionary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_25370",
    "data-name": "Group 25370",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.377,
    height: 18.594,
    viewBox: "0 0 17.377 18.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14061",
    "data-name": "Rectangle 14061",
    width: 17.377,
    height: 18.594
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25374",
    "data-name": "Group 25374",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26717",
    "data-name": "Path 26717",
    d: "M14.877,15.05a4,4,0,0,1,0-8h0V2.093A2.094,2.094,0,0,0,12.786,0H2.092A2.094,2.094,0,0,0,0,2.093V16.5A2.094,2.094,0,0,0,2.092,18.6H14.18a.7.7,0,0,0,0-1.4H2.092a.7.7,0,0,1-.7-.7v-.227H14.18a.7.7,0,0,0,.7-.7V15.05h0m-4.417-9H4.417a.7.7,0,1,1,0-1.4H10.46a.7.7,0,1,1,0,1.4",
    transform: "translate(0 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26718",
    "data-name": "Path 26718",
    d: "M300.454,206.06h-2v-2h-1v2h-2v1h2v2h1v-2h2Z",
    transform: "translate(-283.077 -195.512)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToDictionary);
export default __webpack_public_path__ + "static/media/AddToDictionary.12b8a37cd2a170efe2de9ba38ed8aedc.svg";
export { ForwardRef as ReactComponent };